import { formAnalyticsKey } from '@pkg/modular-blocks/frontend/formAnalytics';
import type { FORM_ERROR } from '@pkg/sanity-utils/types/forms';
import { ampli } from '@pkg/analytics-helper/src/ampli';

/** Provide Amplitude-backed form error tracking to shared FormsBlock. */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(formAnalyticsKey, {
    trackFormError(errorType: FORM_ERROR) {
      ampli.track({
        event_type: 'form_error',
        event_properties: {
          error_type: errorType,
        },
      });
    },
  });
});
